module.exports = __webpack_public_path__ + "3c01ad03036447a0d17f6ae7e7aab427.png";


//////////////////
// WEBPACK FOOTER
// ./content/about/app-screenshots/home.png
// module id = 1299
// module chunks = 0